// sections/DetailPaymentHistorySection.tsx

import { usePayableDetail } from "../../hooks/usePayableDetail";

const DetailPaymentHistorySection = () => {
  const { detail } = usePayableDetail();

  if (!detail) return null;

  const payments = detail.paymentHistory || [];

  return (
    <section
      className="
        rounded-xl
        border border-stroke
        bg-white
        p-6
        shadow-default
        dark:border-strokedark
        dark:bg-boxdark
      "
    >
      <h4 className="mb-5 text-base font-semibold text-black dark:text-white">
        Historial de Pagos
      </h4>

      {payments.length === 0 ? (
        <div
          className="
            rounded-lg
            border border-dashed border-gray
            bg-gray-2
            p-6
            text-center
            dark:border-strokedark
            dark:bg-boxdark-2
          "
        >
          <p className="text-sm text-body dark:text-bodydark">
            No hay pagos registrados para esta Cuenta por Pagar.
          </p>
        </div>
      ) : (
        <div className="space-y-4">
          {payments.map((payment: any) => (
            <div
              key={payment.paymentId}
              className="
                rounded-lg
                border border-gray
                bg-gray-2
                p-5
                dark:border-strokedark
                dark:bg-boxdark-2
              "
            >
              <div className="grid grid-cols-1 gap-4 md:grid-cols-4">
                {/* ID Pago */}
                <div>
                  <p className="mb-1 text-sm font-medium text-body dark:text-bodydark">
                    Pago
                  </p>

                  <p className="font-semibold text-black dark:text-white">
                    PAY-{String(payment.paymentId).padStart(4, "0")}
                  </p>
                </div>

                {/* Fecha */}
                <div>
                  <p className="mb-1 text-sm font-medium text-body dark:text-bodydark">
                    Fecha
                  </p>

                  <p className="font-semibold text-black dark:text-white">
                    {payment.paymentDate || "-"}
                  </p>
                </div>

                {/* Monto */}
                <div>
                  <p className="mb-1 text-sm font-medium text-body dark:text-bodydark">
                    Total pagado
                  </p>

                  <p className="font-bold text-meta-3">
                    ${Number(payment.totalPaid || 0).toFixed(2)}
                  </p>
                </div>

                {/* Estado visual */}
                <div>
                  <p className="mb-1 text-sm font-medium text-body dark:text-bodydark">
                    Registro
                  </p>

                  <span
                    className="
                      inline-flex
                      rounded-full
                      bg-meta-3/10
                      px-3 py-1
                      text-sm
                      font-medium
                      text-meta-3
                    "
                  >
                    Aplicado
                  </span>
                </div>
              </div>

              {/* Notas */}
              {payment.notes && (
                <div className="mt-4 border-t border-stroke pt-4 dark:border-strokedark">
                  <p className="mb-1 text-sm font-medium text-body dark:text-bodydark">
                    Observación
                  </p>

                  <p className="text-sm text-black dark:text-white">
                    {payment.notes}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </section>
  );
};

export default DetailPaymentHistorySection;